import { lazy } from "react";
import Redirect from "../Redirect";
import NotFound from "../../components/ui/page/NotFound";
const ControlPanel = lazy(() => import("../../layout/panel/index"));

const Home = lazy(() => import("../../pages/Home"));
const Cart = lazy(() => import("../../pages/Cart"));
const Summary = lazy(() => import("../../pages/Summary"));
const AdminLogin = lazy(() => import("../../pages/Admin/Login"));

const pagesRoute = [
  {
    path: "/",
    component: Home,
    meta: {
      redirectUrl: "/",
      protectedRoute: false,
      role: "",
    },
  },

  {
    path: "/admin/login",
    component: AdminLogin,
    meta: {
      redirectUrl: "/",
      protectedRoute: false,
      role: "",
    },
  },

  {
    path: "/cart",
    component: Cart,
    meta: {
      redirectUrl: "/",
      protectedRoute: false,
      role: "",
    },
  },

  {
    path: "/summary",
    component: Summary,
    meta: {
      redirectUrl: "/",
      protectedRoute: false,
      role: "",
    },
  },

  {
    path: "/*",
    component: NotFound,
    meta: {
      redirectUrl: "/",
      protectedRoute: true,
      role: "",
    },
  },

  {
    path: "admin/",
    component: ControlPanel,
    meta: {
      redirectUrl: "/",
      protectedRoute: true,
      role: "admin",
    },
  },

  {
    path: "*",
    component: Redirect,
    meta: {
      redirectUrl: "/",
      protectedRoute: false,
      role: "",
    },
  },

  {
    path: "/admin/*",
    component: Redirect,
    meta: {
      redirectUrl: "/",
      protectedRoute: false,
      role: "",
    },
  },
];

export default pagesRoute;
